<template>
  <a href="#" :class="['badge', {lock: isLocked}]" @click.prevent="$emit('click')">
    <template v-if="isLocked">
      <div class="locked">
        <BaseImage src="/static/images/level_locked.svg" alt="locked" />
      </div>
    </template>

    <template v-else>
      <template v-if="hasBadge">
        <div class="has_badge">
          <BaseImage :src="imageSrc" :alt="imageAlt" />

          <div class="mini_badge">{{ badgeContent }}</div>
        </div>
      </template>

      <template v-else>
        <BaseImage :src="imageSrc" :alt="imageAlt" />
      </template>
    </template>

    <p>{{ $_translations.value[name] }}</p>
  </a>
</template>

<script setup>
import BaseImage from '@/components/image/BaseImage.vue';

defineEmits(['click']);

defineProps({
  name: {
    type: String,
    default: '',
  },
  imageSrc: {
    type: String,
    default: '',
  },
  imageAlt: {
    type: String,
    default: '',
  },
  isLocked: {
    type: Boolean,
    default: false,
  },
  hasBadge: {
    type: Boolean,
    default: false,
  },
  badgeContent: {
    type: [String, Number],
    default: '',
  },
});
</script>
